package com.essntl.uikit.components.iconbutton.tinted

import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import com.essntl.uikit.components.button.EsButtonSize
import com.essntl.uikit.components.button.tinted.getTintedButtonColors
import com.essntl.uikit.components.iconbutton.EsIconButton
import com.essntl.uikit.theme.esColorScheme

@Composable
fun EsSmallTintedIconButton(
    onClick: () -> Unit,
    iconRes: String,
    enabled: Boolean = true,
    loading: Boolean = false,
    progress: Float = 0f,
    cancelable: Boolean = false,
    onCancel: () -> Unit = {},
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    modifier: Modifier = Modifier,
) {
    val essntlColorScheme = MaterialTheme.esColorScheme

    EsIconButton(
        onClick = onClick,
        size = EsButtonSize.Small,
        colors = getTintedButtonColors(essntlColorScheme),
        iconRes = iconRes,
        enabled = enabled,
        loading = loading,
        progress = progress,
        cancelable = cancelable,
        onCancel = onCancel,
        interactionSource = interactionSource,
        modifier = modifier,
    )
}